<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="广告所属" prop="typeId">
        <a-select
          show-search
          v-model="form.typeId"
          placeholder="请选择"
          option-filter-prop="children"
          @change="handleChange"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in listType" :key="d.id">{{ d.remark }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="简介说明" prop="overviewVal">
        <a-input v-model="form.overviewVal" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="fileUrl" v-if="size1">
        <file-upload
          type="image"
          :file="form.fileUrl"
          @input="getImg($event, 'fileUrl')"
          :count="1"
          :autoCropHeight="size2"
          :autoCropWidth="size1"
          ref="fileUpload"
        ></file-upload>
      </a-form-model-item>
      <!-- <a-form-model-item label="跳转类型" prop="openType">
        <a-radio-group v-model="form.openType" button-style="solid">
          <a-radio-button :value="0"> 无动作 </a-radio-button>
          <a-radio-button :value="1"> 跳内文本 </a-radio-button>
          <a-radio-button :value="2"> 跳外部地址</a-radio-button>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="详细信息" prop="detailsText" v-if="form.openType == 1">
        <editor v-model="form.detailsText" v-if="form.openType == 1" />
      </a-form-model-item>
      <a-form-model-item label="外部地址" prop="dataUrl" v-if="form.openType == 2">
        <a-input v-model="form.dataUrl" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="开始-结束时间" prop="endTime">
        <!-- <a-range-picker
          @change="onChange"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm"
          :disabled-date="disabledDate"
          :disabled-time="disabledRangeTime"
          v-model="form.reservationTimes"
        /> -->
        <a-range-picker
          @change="onChange"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm"
          v-model="form.reservationTimes"
        />
        <a-input v-model="form.endTime" v-show="isShow"></a-input>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/carousel'
import { typeList } from '@/api/pressure/advertisement'
import editor from '@/components/Editor/Editor.vue'
import moment from 'moment'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: { editor },

  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      size1: '',
      size2: '',
      // 表单参数
      form: {
        id: undefined,
        typeId: undefined,
        title: undefined,
        fileUrl: undefined,
        openType: 1,
        detailsText: undefined,
        dataUrl: undefined,
        endTime: undefined,
        startTime: undefined,
        sort: 99,
        reservationTimes: [],
      },
      open: false,
      isShow: false,
      listType: [],
      inputVisible: false,
      inputVisibles: false,
      showLoading: false,
      rules: {
        typeId: [{ required: true, message: '请选择广告所属', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        overviewVal: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择开始结束时间', trigger: 'blur' }],
        fileUrl: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        detailsText: [{ required: true, message: '请输入详细信息', trigger: 'blur' }],
        dataUrl: [{ required: true, message: '请输入外部地址', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        optionalUnit: [{ required: true, message: '请添加单位', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    this.getType()
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 选择广告所属
    handleChange(e) {
      console.log(e, '顶顶顶顶')
      const query = this.listType.filter((item) => item.id === e)[0]
      console.log(query, 'queryquery')
      const sizes = query.size.split('*')
      this.size1 = sizes[0]
      this.size2 = sizes[1]
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.fileUpload.init(this.size1, this.size2)
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day')
    },
    disabledDateTime() {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      }
    },
    getType() {
      typeList().then((res) => {
        console.log(res, '的点点滴滴')
        this.listType = res.data.records
      })
    },
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.startTime = moment(e[0]).format('YYYY-MM-DD HH:mm')
      this.form.endTime = moment(e[1]).format('YYYY-MM-DD HH:mm')
      console.log(this.form.reservationTime, 'this.form.reservationTime')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        typeId: undefined,
        title: undefined,
        fileUrl: undefined,
        openType: 1,
        detailsText: undefined,
        dataUrl: undefined,
        endTime: undefined,
        startTime: undefined,
        sort: 99,
        reservationTimes: [],
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加轮播'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        console.log(response.data, 'response.data')
        response.data.reservationTimes = [response.data.startTime, response.data.endTime]
        this.form = response.data
        this.handleChange(this.form.typeId)
        this.open = true
        this.formTitle = '修改轮播'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
           this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
             const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
